import Component from './component';
import crossFadeTab from './crossFadeTab';
import createComponentFactory from '../createComponent';
import Swiper from 'swiper/dist/js/swiper.js';
import homeContentList from './homeContentList';

class HomeTopics extends Component {
  constructor(element, context, options) {
    super(element, context, options);

    this.content = this.element.querySelectorAll('.js-homeTopics__content');

    this._handleEntryLoad = this._handleEntryLoad.bind(this);
  }

  _bindEvents() {

  }

  _unbindEvents() {
  }

  _handleEntryLoad() {

  }

  _tabify() {

    this.registerComponent('tab', this.element, crossFadeTab, {
      tabs: '.js-homeTopics__tabs',
      tab: '.js-homeTopics__tab',
      container: '.js-homeTopics__container',
      content: '.js-homeTopics__content'
    });
  }

  _untabify() {
    this.unregisterComponent('tab');
  }

  didRegisterComponent() {
    this._bindEvents();
    this._tabify();
    this.registerComponent('list', '.js-homeTopics__content', homeContentList);
  }

  didUnregisterComponent() {
    this._unbindEvents();
    this._untabify();
    this.unregisterComponent('list');
  }
}

export default createComponentFactory(HomeTopics);



// WEBPACK FOOTER //
// ./src/js/app/component/homeTopics.js